"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var google_maps_react_1 = require("google-maps-react");
var PinInformation_1 = __importDefault(require("~/components/maps/locations/PinInformation"));
var FETCH_INITIAL_STORES_DELAY = 500;
var GoogleMap = (0, mobx_react_1.inject)('googleMapStore')((0, mobx_react_1.observer)(function (props) {
    var googleMapStore = props.googleMapStore;
    var google = props.google, lat = props.lat, lng = props.lng;
    var fetchStores = function (mapProps, map) {
        if (!(props && map)) {
            return;
        }
        var bounds = map.getBounds();
        bounds && googleMapStore.fetchStores(bounds);
    };
    var handleReady = function (mapProps, map) {
        googleMapStore.map = map;
        // NOTE: すぐに呼ぶと map.getBounds() が取れないのでちょっとだけ待つ
        setTimeout(function () { return fetchStores(mapProps, map); }, FETCH_INITIAL_STORES_DELAY);
    };
    var handleClickMarker = function (store) { return function (_, marker) {
        googleMapStore.activeMarker = marker;
        googleMapStore.activeStore = store;
    }; };
    var handleClickMap = function () {
        googleMapStore.activeMarker = null;
        googleMapStore.activeStore = null;
    };
    return (react_1.default.createElement("div", { className: "mapsLocationsGoogleMap-Container" },
        react_1.default.createElement(google_maps_react_1.Map, { centerAroundCurrentLocation: true, google: google, initialCenter: { lat: lat, lng: lng }, onReady: handleReady, onClick: handleClickMap, onDragend: fetchStores, onZoomChanged: fetchStores, 
            // @see https://developers.google.com/maps/documentation/javascript/controls
            // @ts-ignore
            streetViewControl: false },
            googleMapStore.stores.map(function (store) { return react_1.default.createElement(google_maps_react_1.Marker, { key: store.slug, 
                // ライブラリの型定義が死んでるので諦めました
                // @see https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerOptions
                // @ts-ignore
                name: store.name, onClick: handleClickMarker(store), position: { lat: store.latitude, lng: store.longitude } }); }),
            googleMapStore.map && googleMapStore.activeMarker && googleMapStore.activeStore &&
                react_1.default.createElement(google_maps_react_1.InfoWindow, { visible: Boolean(googleMapStore.activeMarker), google: google, map: googleMapStore.map, marker: googleMapStore.activeMarker, 
                    // @see https://developers.google.com/maps/documentation/javascript/reference/info-window#InfoWindowOptions
                    // @ts-ignore
                    position: new google.maps.LatLng(googleMapStore.activeStore.latitude, googleMapStore.activeStore.longitude) },
                    react_1.default.createElement(PinInformation_1.default, { store: googleMapStore.activeStore })))));
}));
exports.default = (0, google_maps_react_1.GoogleApiWrapper)({
    apiKey: GOOGLE_MAP_API_KEY,
    language: 'ja'
})(GoogleMap);
